import React from "react";

const ChartLegend = ({ data, symbol }) => {
  return (
    <div className="chart-legend-wrapper">
      {data &&
        data.map((item, i) => (
          <div className="legend-item" key={i}>
            <div className="left">
              <b>{item.value}</b>
              <span>{symbol ? symbol : "Cr"}</span>
            </div>

            <div className="right">
              <i style={{ background: item?.color }}></i>
              <b>{item.label}</b>
              <span>{item?.percent && `${item.percent}%`}</span>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ChartLegend;
